
import { defineComponent } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "CharactersTabs",
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);
		const { changeCharacter, removeCharacter, addNewCharacter } = store;

		return {
			characters,
			current,
			changeCharacter,
			removeCharacter,
			addNewCharacter,
		};
	},
	methods: {
		shortenName(name: string) {
			return name;
		},
	},
});
